// Orders
import OrderBrand from "./orders/OrderBrand";
import OrderCity from "./orders/OrderCity";
import OrderClimaticFeature from "./orders/OrderClimaticFeature";
import OrderCountry from "./orders/OrderCountry";
import OrderDateAndHour from "./orders/OrderDateAndHour";
import OrderDay from "./orders/OrderDay";
import OrderDayWeek from "./orders/OrderDayWeek";
import OrderDeliveryFee from "./orders/OrderDeliveryFee";
import OrderMoisture from "./orders/OrderMoisture";
import OrderMonth from "./orders/OrderMonth";
import OrderNeighborhood from "./orders/OrderNeighborhood";
import OrderOriginSale from "./orders/OrderOriginSale";
import OrderSourceData from "./orders/OrderSourceData";
import OrderState from "./orders/OrderState";
import OrderTemperature from "./orders/OrderTemperature";
import OrderThermalSensation from "./orders/OrderThermalSensation";
import OrderUnit from "./orders/OrderUnit";
import OrderValue from "./orders/OrderValue";
import OrderWeek from "./orders/OrderWeek";
import OrderYear from "./orders/OrderYear";

// Customers
import CustomerAverageTicket from "./customers/CustomerAverageTicket";
import CustomerBirthday from "./customers/CustomerBirthday";
import CustomerDateAndHour from "./customers/CustomerDateAndHour";
import CustomerDayRegistration from "./customers/CustomerDayRegistration";
import CustomerDayWeekRegistration from "./customers/CustomerDayWeekRegistration";
import CustomerDoc from "./customers/CustomerDoc";
import CustomerEmail from "./customers/CustomerEmail";
import CustomerFrequencyOrders from "./customers/CustomerFrequencyOrders";
import CustomerGender from "./customers/CustomerGender";
import CustomerHourRegistration from "./customers/CustomerHourRegistration";
import CustomerLastAtt from "./customers/CustomerLastAtt";
import CustomerLastOrder from "./customers/CustomerLastOrder";
import CustomerMarketing from "./customers/CustomerMarketing";
import CustomerMonthRegistration from "./customers/CustomerMonthRegistration";
import CustomerName from "./customers/CustomerName";
import CustomerPhone from "./customers/CustomerPhone";
import CustomerQuantityOrders from "./customers/CustomerQuantityOrders";
import CustomerRFV from "./customers/CustomerRFV";
import CustomerTotalSpend from "./customers/CustomerTotalSpend";
import CustomerWeekRegistration from "./customers/CustomerWeekRegistration";
import CustomerYearRegistration from "./customers/CustomerYearRegistration";

// Coupons
import CouponCode from "./coupons/CouponCode";
import CouponDay from "./coupons/CouponDay";
import CouponDayAndHour from "./coupons/CouponDayAndHour";
import CouponDayWeek from "./coupons/CouponDayWeek";
import CouponDaysExp from "./coupons/CouponDaysExp";
import CouponDiscount from "./coupons/CouponDiscount";
import CouponExpDate from "./coupons/CouponExpDate";
import CouponExpDateReminder from "./coupons/CouponExpDateReminder";
import CouponHour from "./coupons/CouponHour";
import CouponMinOrder from "./coupons/CouponMinOrder";
import CouponMonth from "./coupons/CouponMonth";
import CouponType from "./coupons/CouponType";
import CouponWeek from "./coupons/CouponWeek";
import CouponYear from "./coupons/CouponYear";

// Products
import CustomerDaysWithoutConversion from "./customers/CustomerDaysWithoutConversion";
import ProductCategory from "./products/ProductCategory";
import ProductDay from "./products/ProductDay";
import ProductDayAndHour from "./products/ProductDayAndHour";
import ProductDayWeek from "./products/ProductDayWeek";
import ProductHour from "./products/ProductHour";
import ProductMonth from "./products/ProductMonth";
import ProductName from "./products/ProductName";
import ProductQuantity from "./products/ProductQuantity";
import ProductSKU from "./products/ProductSKU";
import ProductSize from "./products/ProductSize";
import ProductValue from "./products/ProductValue";
import ProductWeek from "./products/ProductWeek";
import ProductYear from "./products/ProductYear";
import ProfileClimate from "./profiles/ProfileClimate";
import ProfileMomentDay from "./profiles/ProfileMomentDay";
import ProfileMomentWeek from "./profiles/ProfileMomentWeek";
import ProfileRFV from "./profiles/ProfileRFV";
import ProfileSeason from "./profiles/ProfileSeason";
import ProfileTemperature from "./profiles/ProfileTemperature";
import CustomerAge from "./customers/CustomerAge";

export const Components = {
  // Orders
  OrderDateAndHour,
  OrderValue,
  OrderDeliveryFee,
  OrderBrand,
  OrderUnit,
  OrderSourceData,
  OrderOriginSale,
  OrderCity,
  OrderState,
  OrderCountry,
  OrderNeighborhood,
  OrderTemperature,
  OrderThermalSensation,
  OrderMoisture,
  OrderClimaticFeature,
  OrderYear,
  OrderDay,
  OrderWeek,
  OrderDayWeek,
  OrderMonth,
  // Customers
  CustomerAge,
  CustomerDateAndHour,
  CustomerName,
  CustomerEmail,
  CustomerPhone,
  CustomerDoc,
  CustomerBirthday,
  CustomerGender,
  CustomerLastAtt,
  CustomerTotalSpend,
  CustomerQuantityOrders,
  CustomerRFV,
  CustomerAverageTicket,
  CustomerFrequencyOrders,
  CustomerLastOrder,
  CustomerMarketing,
  CustomerHourRegistration,
  CustomerDayRegistration,
  CustomerWeekRegistration,
  CustomerDayWeekRegistration,
  CustomerYearRegistration,
  CustomerMonthRegistration,
  CustomerDaysWithoutConversion,
  // Coupons
  CouponDayAndHour,
  CouponCode,
  CouponType,
  CouponDiscount,
  CouponMinOrder,
  CouponDaysExp,
  CouponExpDate,
  CouponExpDateReminder,
  CouponHour,
  CouponDay,
  CouponWeek,
  CouponDayWeek,
  CouponMonth,
  CouponYear,
  // Products
  ProductDayAndHour,
  ProductSKU,
  ProductName,
  ProductQuantity,
  ProductHour,
  ProductValue,
  ProductSize,
  ProductCategory,
  ProductYear,
  ProductMonth,
  ProductDay,
  ProductWeek,
  ProductDayWeek,

  ProfileClimate,
  ProfileMomentDay,
  ProfileMomentWeek,
  ProfileRFV,
  ProfileSeason,
  ProfileTemperature,
};
